module.exports = __webpack_public_path__ + "static/media/objectiveC.05c17123.svg";